export type FilterDefaults = {
  locationIds: string[]
  locationGroupIds: string[]
}

export type FilterUpdates = { locationIds?: string[]; locationGroupIds?: string[] }

// The URL update that applies the user's default filters to the Requests page, in one
// object so the location and location group defaults cannot overwrite each other.
// Locations default only when none are selected. Group ids from the URL stand; otherwise
// groups default when none are selected, and a selected group that is gone drops out.
export const filterDefaultUpdates = (
  current: FilterDefaults,
  defaults: FilterDefaults,
  groupIdsFromUrl: boolean
): FilterUpdates => {
  const updates: FilterUpdates = {}

  if (current.locationIds.length === 0 && defaults.locationIds.length > 0) {
    updates.locationIds = defaults.locationIds
  }

  if (!groupIdsFromUrl) {
    const freshIds = defaults.locationGroupIds
    const currentIds = current.locationGroupIds

    if (currentIds.length === 0 && freshIds.length > 0) {
      updates.locationGroupIds = freshIds
    } else if (currentIds.some((id) => !freshIds.includes(id))) {
      updates.locationGroupIds = currentIds.filter((id) => freshIds.includes(id))
    }
  }

  return updates
}
